import { useAdvisors } from 'src/clients/hooks/useAdvisors';
import { useClients } from 'src/clients/hooks/useClients';
import type { Notification } from 'src/notifications/types/Notification';

export function useNotificationAdvisors(enabled: boolean) {
  const { advisors } = useAdvisors(enabled);
  const { clients } = useClients({}, { enabled });

  const clientAdvisor = new Map<string, string | null>(
    clients.map((client): [string, string | null] => [client.id, client.advisorUserId ?? null]),
  );

  const advisorOf = (notification: Notification): string | null => {
    const clientId = notification.payload.client_id;
    return clientId ? (clientAdvisor.get(clientId) ?? null) : null;
  };

  return { advisors, advisorOf };
}
